<!-- 编辑页面 -->
<template>
    <div class='editor-box'>
        <e-header :dragGroup="dragGroup" :currentNode="currentNode" @deleteNode="deleteNode"></e-header>
        <div class="editor-wapper">
            <e-plan :dragGroup="dragGroup" @changeSence="changeSence"></e-plan>
            <div class="draw-box" ref="drawing">
                <div id="drawing" 
                    @drop="drop" @dragover.prevent></div>
            </div>
            <e-utilbox></e-utilbox>
        </div>

        <!-- 绑定参数地址框 -->
        <cmp-bindaddr-dialog :scens="scens" :visible="visible" :form="itemData" @handleCloseDialog="handleCloseDialog"></cmp-bindaddr-dialog>

        <!-- 绑定水流地址框 -->
        <cmp-line-dialog :scens="scens" :visible="visibleLine" :form="itemLineData" @handleCloseDialog="handleLineCloseDialog"></cmp-line-dialog>

        <!-- 绑定按钮地址框 -->
        <cmp-button-dialog :scens="scens"  :visible="visibleButton" :form="itemButtonData" @handleCloseDialog="handleButtonCloseDialog"></cmp-button-dialog>
    </div>
</template>

<script>
import eHeader from './eHeader'
import ePlan from './ePlan'
import eUtilbox from './eUtilbox'
import cmpBindaddrDialog from './cmpBindaddrDialog'
import cmpLineDialog from './cmpLineDialog'
import cmpButtonDialog from './cmpButtonDialog'

import Storage from '@/utils/storage'
import bus from "@/utils/bus";

let dragIng = false     //  判断text拖动状态
export default {
    name:  'editor',
    data() {
        return {
            drag: null,
            dragGroup: null,
            groupZoom: null, 

            mySvg: null,
            scens: null,

            currentNode: null,  //  当前选择节点
            zoom: 1,

            visible: false,
            itemData: {},
            visibleLine: false,
            itemLineData: {},
            visibleButton: false,
            itemButtonData: {},
        };
    },

    components: { eHeader, ePlan, eUtilbox, cmpBindaddrDialog, cmpLineDialog, cmpButtonDialog },

    mounted() {
        let that = this;
        this.$nextTick(()=>{
            let width = this.$refs.drawing.offsetWidth
            let height = this.$refs.drawing.offsetHeight
            
            this.drag = new SVG("drawing").size(width - 20, height - 20);
        })

        bus.$on('copy', async ()=>{
           if(this.currentNode === null) {
                console.log("请选择要复制的节点");
                return
            }
            let x = this.currentNode.x(),
                y = this.currentNode.y(),
                clone = this.currentNode.clone();

            clone.move(x + 50,y + 50)

            this.dragGroup.add(clone)
        })
    },

    methods: {
        // 切换场景
        changeSence(v){
            this.currentNode = null
            let that = this;
            if(this.dragGroup !== null) {
                this.dragGroup.clear()
            }
            if(v === null) {
                this.dragGroup = this.drag.group()
                this.groupZoom = this.dragGroup.panZoom()
                return
            }
            this.scens = v;     //  存储场景内容
            let svgData = v.map_value_computer
            this.drag.svg(svgData)
            this.dragGroup = this.drag.last()
            let children = this.dragGroup.children()
            // 递归节点
            function bindClick(nodes) {
                if(nodes.length<=0) return false
                for (let i = 0; i < nodes.length; i++) {
                    const element = nodes[i];
                    element.node.dataset
                    if(element.type === 'g'){
                        bindClick(element.children())
                    }else{
                        if(element.type === 'text') {
                            if(element.node.dataset.type !== 'NB' && element.node.dataset.type !== 'WB') {
                                let tspan = element.node.firstChild
                                if(tspan && tspan.nodeName === 'textPath') {
                                    let id = tspan.href.baseVal.substring(1)
                                    that.drag.defs().path('M0,2 150,2').attr("id", id)
                                }
                                // 点击按钮文本
                                element.on('click', function(e) {
                                    let value = this.text()
                                    // 清楚之前选框
                                    if(!!that.currentNode) {
                                        that.currentNode.selectize(false).resize("stop")
                                    }
                                    that.currentNode = element;
                                    that.openInput(value)
                                    // 阻止事件冒泡
                                    e= window.event || e;
                                    if(document.all){  //只有ie识别
                                        e.cancelBubble=true;
                                    }else{
                                        e.stopPropagation();
                                    }
                                })
                            }else{
                                element.draggable().on('click', function(e) {
                                    if(element.node.dataset.type === 'WB'){
                                       that.currentNode = element; 
                                    }else{
                                         that.currentNode = this.parent();
                                    }
                                    e= window.event || e;
                                    if(document.all){  //只有ie识别
                                        e.cancelBubble=true;
                                    }else{
                                        e.stopPropagation();
                                    }
                                    // 通知属性面板
                                    bus.$emit('clickNode', element)
                                })
                            }
                            element.draggable()
                        }else{
                            element.draggable().on('dragend', e=>{
                                let type = e.detail.handler.el.node.dataset.type
                                // 处理按钮
                                if(type === "BUTTON") {
                                    let button_text = e.detail.handler.el.next()
                                    let x = e.detail.handler.el.x(),
                                    y = e.detail.handler.el.y()
                                    let text = e.detail.handler.el.next()
                                    button_text.translate(x, y)
                                }
                            })
                            element.on('click', function(e) {
                                that.clearSelect()
                                // 如果是按钮，当前节点指向g组
                                if(element.parent().type === 'g' && Array.from(element.parent().node.classList).indexOf('e-button-group')>-1 ){
                                    that.currentNode = element.parent()
                                }else{
                                    that.currentNode = element
                                    element.selectize().resize();
                                    e.preventDefault();
                                }
                                // 通知属性面板
                                bus.$emit('clickNode', element)
                            })
                        }
						//界面元素点击事件
                        element.on('dblclick', function(e) {
                            let dataset = this.node.dataset
                            if(!dataset.type) return
                            if(dataset.type === 'BUTTON') {
                                // 按钮
                                let dataset = this.parent().node.dataset
                                that.visibleButton = true
                                that.itemButtonData = { dataset }
                                return
                            }
                            if(dataset.type === 'NB') {
                                // 数字
                                let dataset = this.parent().node.dataset
                                that.visible = true
                                that.itemData = { dataset }
                                return
                            }
                            if(dataset.type.indexOf("LINE") > -1) {
                                // 水流
                                that.visibleLine = true
                                that.itemLineData = { dataset }
                            }else{
                                that.visible = true
                                that.itemData = { dataset }
                            }
                        })
                    }
                }
            }
            bindClick(children)
            //支持缩放
            this.groupZoom = this.dragGroup.panZoom()
            let svg_id = this.drag.node.id
            var panZoom1 = window.panZoom = svgPanZoom('#' + svg_id , {
                zoomEnabled: true,
                controlIconsEnabled: true,
                fit: 1,
                center: 1,
				minZoom:0.5,
				maxZoom:5
            });
            
            window.resize = function () {
                panZoom1.resize();
                panZoom1.fit();
                panZoom1.center();
            }
            
            this.drag.on('click', function(e) {
				
                if(!e.target.dataset.type) {
                    bus.$emit('clickNode', null)
                    // 点击空白区
                    if(!!that.currentNode) {
                        that.currentNode.selectize(false).resize("stop")
						
                    }
                    that.currentNode = null
                }
            })
        },
        drop(event){
            let data = JSON.parse(event.dataTransfer.getData('data'));
            let matrix = this.dragGroup.transform()
            let scaleX = matrix.scaleX  //  X缩放
            let scaleY = matrix.scaleY  //  Y缩放
            let v_x = matrix.x  // 画板坐标圆点X
            let v_y = matrix.y  // 画板坐标圆点Y
            let x = ((event.layerX ? event.layerX : event.offsetX)-v_x)/scaleX,     // 计算位置：(鼠标位置-画板坐标圆点)/缩放尺寸
                y = ((event.layerY ? event.layerY : event.offsetY)-v_y)/scaleY,
                w = data.width,
                h = data.height;
            switch (data.type) {
                case 'WB':
                    this.addText(data, {x, y, w, h})
                    break;
                case 'NB':
                    this.addNumber(data, {x, y, w, h})
                    break;
                case 'BUTTON':
                    this.addButton(data, {x, y, w, h})
                    break;
                case 'LINE_H':
                    this.addLine(data, {x, y, w, h}, "H")
                    break;
                case 'LINE_V':
                    this.addLine(data, {x, y, w, h}, "V")
                    break;
                case 'LINE_D':
                    this.addDefaultLine(data, {x, y, w, h})
                    break;
                default:
                    this.addImage(data, {x, y, w, h})
                    break;
            }
            
            this.clearSelect()
            event.stopPropagation()
            event.preventDefault();
        },
        // 增加数字
        addNumber(data, pos) {
            let that = this
            let {x, y} = pos
            let g = this.dragGroup.group().move(x, y).attr({
                'data-type': data.type,
                'class': 'e_device e_number',
            })
            g.text('0.00').attr({
                'data-type': data.type,
            }).font({
                family:'Helvetica',size:30,anchor:'middle',leading:  '1.5em'
            }).fill('#266cba')
            g.draggable()
            this.binddblClick(g)

            let text = g.children()[0]
            text.on('click', function(e) {
                bus.$emit('clickNode', text)
                // 阻止事件冒泡
                e= window.event || e;
                if(document.all){  //只有ie识别
                    e.cancelBubble=true;
                }else{
                    e.stopPropagation();
                }
                e.preventDefault();

                // 通知属性面板
                bus.$emit('clickNode', text)
            })
            bus.$emit('clickNode', text)
        },
        // 增加设备
        addImage(data, pos) {
            let that = this
            let {x, y, w, h} = pos
            let image = this.dragGroup.image(data.icon, w, h).move(x, y).attr('data-type', data.type).attr('class', 'e_device')
            if(data.type.indexOf('GD') > -1) {
                image.attr('preserveAspectRatio', "none")
            }
            if(data.type.indexOf('WARN') > -1) {
                image.attr('class', "e_device e_warn")
            }
            image.draggable()
            image.on('click', function(e) {
                that.clearSelect()
                that.currentNode = image
                image.selectize().resize();
                e.preventDefault();
            })
            this.binddblClick(image)
        },
        // 增加文本
        addText(data, pos) {
            let that = this
            let {x, y} = pos

            let text = this.dragGroup.plain('默认内容')
            .move(x, y)
            .attr('data-type', data.type).attr('class', 'e_device e_text')
            .font({
                family:'Helvetica',size:14,anchor:'middle',leading:  '1.5em'
            })
            text.draggable()
            text.on('click', function(e) {
                let value = this.text()
                that.currentNode = text;
                // that.openInput(value)
                // 阻止事件冒泡
                e= window.event || e;
                if(document.all){  //只有ie识别
                    e.cancelBubble=true;
                }else{
                    e.stopPropagation();
                }
                e.preventDefault();

                // 通知属性面板
                bus.$emit('clickNode', text)
            })
            bus.$emit('clickNode', text)
        },
        // 增加按钮
        addButton(data, pos) {
            
            let that = this
            let {x, y} = pos
            let g = this.dragGroup.group().move(x, y).attr({
                'class': 'e_device e-button-group',
            })
            let rect = this.drag.rect(150, 40).fill('#266cba').attr({
                'data-type': data.type,
                'class': 'e_device e-button-rect',
            })
            let button_text = this.drag.text('按钮').attr({
                'class': 'e_device e-button-text',
            }).style({
                family:'Helvetica',size:14,fill: '#ffffff',
            })
            button_text.attr({
                fill:'none'
            });
            button_text.path("M0,2 150,2").textPath().attr({
                startOffset: '50%',
                'text-anchor':'middle',
                'dominant-baseline':'middle'
            });
            g.add(rect);
            g.add(button_text);
            rect.draggable().on('dragend', e=>{
                let x = e.detail.handler.el.x(),
                y = e.detail.handler.el.y()
                let text = e.detail.handler.el.next()
                button_text.translate(x, y)
            })
            rect.on('click', function(e) {
                that.clearSelect()
                // rect.selectize().resize();
                that.currentNode = rect;
                e.preventDefault();
            })
            button_text.on('click', function(e) {
                let value = button_text.text()
                that.currentNode = button_text;
                that.openInput(value)
                // 阻止事件冒泡
                e= window.event || e;
                if(document.all){  //只有ie识别
                    e.cancelBubble=true;
                }else{
                    e.stopPropagation();
                }
            })
            this.binddblClick(rect)
        },
        // 增加水流线
        addLine(data, pos, dir) {
            let that = this
            let {x, y} = pos
            let polyline
            if(dir === 'V') {
                polyline = this.dragGroup.line(0,100,100,100).stroke({ width: 3 })
            }else{
                polyline = this.dragGroup.line(100,0,100,100).stroke({ width: 3 })
            }
            polyline.move(x, y).attr({
                'data-type':data.type,
                'class':'e_device e_polyline',
            })
            polyline.draggable()
            polyline.on('click', function(e) {
                that.clearSelect()
                that.currentNode = polyline
                polyline.selectize().resize();
                e.preventDefault();
            })
            this.binddblClick(polyline)
        },
        // 增加线条
        addDefaultLine(data, pos) {
            let that = this
            let {x, y} = pos
            let polyline
            polyline = this.dragGroup.line(0,100,100,100).stroke({ width: 1,color: '#666', })
            polyline.move(x, y).attr({
                'data-type':data.type,
                'class':'e_device e_defaultline',
            })
            polyline.draggable()
            polyline.on('click', function(e) {
                that.clearSelect()
                that.currentNode = polyline
                polyline.selectize().resize();
                e.preventDefault();
                bus.$emit('clickNode', polyline)
            })
            bus.$emit('clickNode', polyline)
        },
        // 清楚选中
        clearSelect() {
            if(!!this.currentNode) {
                this.currentNode.selectize(false).resize("stop")
            }
        },
        binddblClick(dom){
            let that = this
			
            dom.on('dblclick', function(e) {
                e.preventDefault();
                
                if(dom.node.dataset.type === 'BUTTON') {
                    that.currentNode = dom.parent()
                }else{
                    that.currentNode = dom
                }
                let dataset = this.node.dataset
                if(!dataset.type) return
                if(dataset.type === 'BUTTON') {
                    // 按钮
                    that.visibleButton = true
                    that.itemButtonData = { dataset }
                    return
                }
                if(dataset.type.indexOf("LINE") > -1) {
                    // 水流
                    that.visibleLine = true
                    that.itemLineData = { dataset }
                }else{
                    that.visible = true
                    that.itemData = { dataset }
                }
            })
        },
        openInput(defaultValue) {
            let that = this
            this.$prompt('请输入内容', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputValue: defaultValue,
            }).then(({ value }) => {
                that.currentNode.text(value)
            }).catch(()=>{
                dragIng = false
            })
        },
        deleteNode(data) {
            if(data) {
                this.currentNode = null;
            }
        },
        // 绑定设备变量关闭事件
        handleCloseDialog(data) {
            this.visible = false;
            if(data.flag){
                this.currentNode.attr('data-params', JSON.stringify(data.data))
            }
        },
        // 设置水流参数关闭事件
        handleLineCloseDialog(data) {
            this.visibleLine = false;
            if(data.flag){
                this.currentNode.attr('class', 'e_device e_polyline '+ `${data.data.colorLine}`)
                this.currentNode.attr('data-params', JSON.stringify(data.data))
            }
        },
        handleButtonCloseDialog(data) {
            this.visibleButton = false;
            if(data.flag){
                var jdata = JSON.stringify(data.data);
                this.currentNode.attr('data-params', jdata)
            }
        },
    }
}

</script>
<style lang='less' scoped>
.editor-box{
    height: 100%;
    text-align: left;
    .editor-wapper{
        position: relative;
        width: 100%;
        height: calc(100% - 74px);
        overflow: hidden;
        .draw-box{
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 220px;
            z-index: 100;
            padding: 10px;
            background-color: #f8f8f8;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAwIDQgTCAxNiA0IE0gNCAwIEwgNCAxNiBNIDAgOCBMIDE2IDggTSA4IDAgTCA4IDE2IE0gMCAxMiBMIDE2IDEyIE0gMTIgMCBMIDEyIDE2IiBmaWxsPSJub25lIiBzdHJva2U9IiNlMGUwZTAiIG9wYWNpdHk9IjAuMiIgc3Ryb2tlLXdpZHRoPSIxIi8+PHBhdGggZD0iTSAxNiAwIEwgMCAwIDAgMTYiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2UwZTBlMCIgc3Ryb2tlLXdpZHRoPSIxIi8+PC9wYXR0ZXJuPjwvZGVmcz48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJ1cmwoI2dyaWQpIi8+PC9zdmc+")
        }
    }
}
</style>